import { Badge } from '@/components/ui/Badge';

import {
  MEMBER_STATUS_LABEL,
  MEMBER_STATUS_TONE,
  type MemberStatus,
} from '../../schemas/member.schema';

export function MemberStatusBadge({ status }: { status: MemberStatus }) {
  return (
    <Badge tone={MEMBER_STATUS_TONE[status]} dot>
      {MEMBER_STATUS_LABEL[status]}
    </Badge>
  );
}
